export const DEFAULT_LANG = 'en-us';

export const DEFAULT_CURRENCY_ISO = 'USD';

export const ALL_LANGS = ['en-us', 'en-ca', 'en-gb'];



// WEBPACK FOOTER //
// ../shared/js/constants/i18n/language.js